var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgK2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38.463,
    height: 38.463,
    viewBox: "441 2166 38.463 38.463",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "integration"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M457.828 2180.424h-14.424a2.407 2.407 0 0 1-2.404-2.404v-9.616a2.407 2.407 0 0 1 2.404-2.404h14.424a2.407 2.407 0 0 1 2.404 2.404v9.616a2.407 2.407 0 0 1-2.404 2.404Zm-14.424-12.821a.802.802 0 0 0-.801.801v9.616c0 .442.359.801.801.801h14.424a.802.802 0 0 0 .801-.801v-9.616a.802.802 0 0 0-.801-.801h-14.424Z",
    fill: "#fff",
    fillRule: "evenodd",
    "data-name": "Path 2343"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.02 2183.629h-4.808a.802.802 0 0 1 0-1.603h4.808a.802.802 0 0 1 0 1.603Z",
    fill: "#fff",
    fillRule: "evenodd",
    "data-name": "Path 2344"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.616 2183.629a.802.802 0 0 1-.801-.801v-3.206a.802.802 0 0 1 1.602 0v3.206a.802.802 0 0 1-.801.801Z",
    fill: "#fff",
    fillRule: "evenodd",
    "data-name": "Path 2345"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.06 2201.258h-14.424a2.407 2.407 0 0 1-2.404-2.404v-9.616a2.407 2.407 0 0 1 2.404-2.404h14.423a2.407 2.407 0 0 1 2.404 2.404v9.616a2.407 2.407 0 0 1-2.404 2.404Zm-14.424-12.821a.802.802 0 0 0-.802.801v9.616c0 .442.36.801.802.801h14.423a.802.802 0 0 0 .802-.8v-9.617a.802.802 0 0 0-.802-.801h-14.423Z",
    fill: "#fff",
    fillRule: "evenodd",
    "data-name": "Path 2346"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.251 2204.463h-4.807a.802.802 0 0 1 0-1.602h4.807a.802.802 0 0 1 0 1.602Z",
    fill: "#fff",
    fillRule: "evenodd",
    "data-name": "Path 2347"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.848 2204.463a.802.802 0 0 1-.802-.8v-3.206a.802.802 0 0 1 1.603 0v3.205a.802.802 0 0 1-.801.801Z",
    fill: "#fff",
    fillRule: "evenodd",
    "data-name": "Path 2348"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.642 2174.013h-2.404a.8.8 0 1 1 0-1.602h2.404a.802.802 0 0 1 0 1.602Z",
    fill: "#fff",
    fillRule: "evenodd",
    "data-name": "Path 2349"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.251 2177.952a.802.802 0 0 1-.8-.8v-.735a2.41 2.41 0 0 0-1.762-2.317.803.803 0 0 1-.56-.986.805.805 0 0 1 .986-.56 4.018 4.018 0 0 1 2.938 3.863v.734a.802.802 0 0 1-.802.801Z",
    fill: "#fff",
    fillRule: "evenodd",
    "data-name": "Path 2350"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.251 2183.629a.802.802 0 0 1-.8-.801v-2.404a.802.802 0 0 1 1.602 0v2.404a.802.802 0 0 1-.802.801Z",
    fill: "#fff",
    fillRule: "evenodd",
    "data-name": "Path 2351"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.225 2198.053h-2.404a.802.802 0 0 1 0-1.603h2.404a.802.802 0 0 1 0 1.603Z",
    fill: "#fff",
    fillRule: "evenodd",
    "data-name": "Path 2352"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.561 2197.937a.834.834 0 0 1-.214-.028 4.018 4.018 0 0 1-2.936-3.863v-.734a.802.802 0 0 1 1.602 0v.734a2.41 2.41 0 0 0 1.762 2.318.803.803 0 0 1-.214 1.573Z",
    fill: "#fff",
    fillRule: "evenodd",
    "data-name": "Path 2353"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.212 2190.84a.802.802 0 0 1-.801-.8v-2.404a.802.802 0 0 1 1.602 0v2.404a.802.802 0 0 1-.801.8Z",
    fill: "#fff",
    fillRule: "evenodd",
    "data-name": "Path 2354"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgK2);
export default __webpack_public_path__ + "static/media/k2.ba729f2699c05c91cc3455757d7162ba.svg";
export { ForwardRef as ReactComponent };